import React from 'react';
import clsx from 'clsx';
import { useFeatures } from 'reaxl-features';
import { PageSection, Section } from 'reaxl';
import Title from './Title.js';
import { jsx } from 'react/jsx-runtime';
function MyWalletGridLight(_ref) {
  let {
    sectionProps = {},
    titleProps = {},
    componentName = 'PageSection',
    children,
    showIcon
  } = _ref;
  const {
    global_kbb_branded_wallet: [enableKbbBrandedWallet]
  } = useFeatures(['global_kbb_branded_wallet']);
  const isPageSection = componentName === 'PageSection';
  const {
    className,
    isRightRail,
    ...rest
  } = sectionProps;
  const props = {
    alignment: 'left',
    className: clsx(className, 'padding-0', {
      'col-lg-8': isPageSection
    }),
    heading: /*#__PURE__*/jsx(Title, {
      uiContext: "white",
      showIcon: showIcon,
      ...titleProps
    }),
    uiContext: isRightRail ? 'section-5' : 'section-4',
    headingClassName: clsx('padding-left-5 margin-horizontal-0 margin-bottom-0 bg-primary border-blue border-bottom-0 rounded-top', {
      'display-flex align-items-center': enableKbbBrandedWallet
    }),
    ...(isPageSection && {
      sectionContainerClassNames: 'margin-right-lg-5'
    }),
    children,
    sectionBodyClassName: 'border-neutral-secondary border-top-0 rounded-bottom',
    ...rest
  };
  return /*#__PURE__*/React.createElement(isPageSection ? PageSection : Section, props);
}
export { MyWalletGridLight as default };
